import { ApplicationState } from '@mews-commander/types';
import { createAction, createReducer } from '@mews/framework';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createBaseEntitySelectors } from './utils';

const REBATE_REASONS_LOADED = prefix('REBATE_REASONS_LOADED');

export const NAME = 'rebateReasons';

export const rebateReasonsReducer = createReducer([], {
    [REBATE_REASONS_LOADED]: (_: string[], rebateReasons: string[]) => rebateReasons,
});

export const [getRebateReasons] = createBaseEntitySelectors<ApplicationState, string, typeof NAME>(
    moduleSelector,
    NAME
);

export const setRebateReasons = (rebateReasons: string[]) => createAction(REBATE_REASONS_LOADED, rebateReasons);
